import { createFileRoute, redirect } from '@tanstack/react-router'

import { flightResultsSearchSchema } from '@/lib/schemas/flight-results-search.schema'

export const Route = createFileRoute('/_booking/flights/results')({
  validateSearch: flightResultsSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/vols/resultats', search, replace: true })
  },
})
